export default defineAppConfig({
  ui: {
    colors: {
      primary: "primary",
      secondary: "secondary"
    },
    button: {
      slots: {
        base: ['rounded-none']
      }
    },
    select: {
      default: {
        trailingIcon: "heroicons:chevron-down-20-solid"
      }
    },
    accordion: {
      props: {
        trailingIcon: "heroicons:chevron-right-20-solid"
      }
    },
    icons: {
      close: 'heroicons:x-mark-16-solid',
      check: 'heroicons:check-16-solid',
      chevronDown: "heroicons:chevron-down-20-solid"
    },
    breadcrumb: {
      slots: {
        link: "text-slate-200"
      },
      variants: {
        active: {
          true: {
            link: "text-primary-200 active font-normal"
          },
          false: {
            link: "hover:text-slate-100 text-slate-200 hover:underline text-slate font-normal"
          }
        }, to: {
          true: "text-slate-200 hover:underline text-slate hover:text-red-500 font-normal hover:text-slate-100!"
        }
      }, compoundVariants: [
        {
          disabled: false,
          active: false,
          to: true,
          class: {
            link: [
              'hover:text-default',
              'transition-colors'
            ]
          }
        }
      ]
    },
    table: {
      default: {
        loadingState: {
          icon: 'octicon:sync-24'
        },
        emptyState: {
          icon: 'octicon:database-24'
        }
      }
    }
  },
  docus: {
    website: 'Pathway',
    title: 'Pathway - Power Your AI with Live Data',
    description: 'Python ETL framework for stream processing, real-time analytics, RAG, and LLM pipelines.',
    layout: 'docs',
    // image: '/assets/pathway-thumbnail.gif',
    url: 'https://pathway.com',
    debug: false,
    socials: {
      twitter: '@pathway_com',
      // discourse: 'https://forum.pathway.com/',
      discord: 'https://discord.com/invite/pathway',
      github: 'https://github.com/pathwaycom/'
    },
    github: {
      root: 'docs/content',
      edit: false,
      releases: false
    },
    cover: {
      src: '/assets/pathway-thumbnail.gif',
      alt: 'Pathway - Power Your AI with Live Data'
    },
    aside: {
      level: 1,
      collapsed: true
    },
    header: {
      title: false,
      logo: true
    },
    footer: {
      credits: {
        icon: '',
        text: '',
        href: ''
      },
      content: {
        text: '',
        href: ''
      },
      icons: [
        {
          label: 'Linkedin',
          href: 'https://www.linkedin.com/company/pathway/',
          component: 'fa6-brands:linkedin'
        }
      ]
    }
  }
})
